import React, { Fragment } from "react"
import styled from "styled-components"
import {
  fetchData,
  removeData,
  showToast,
  setHeaderTitle,
  saveData,
  showPopup,
  hidePopup,
} from "../../store/action"
import uuid from "uuid"
import Cookie from "../../util/Cookie"
import PageHeader from "../PageHeader"
import HorizontalScroll from "../../components/horizontalScroll/HorizontalScroll"
import { Card } from "../../components/horizontalScroll/Card"
import { trendingBids } from "../../dummyData"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import { replaceWithSymbol } from "../../util/cutString"
import { secondsToHms } from "../../util/Utility"
import config from "../../Config"
import i18n from "../../i18n"
import BidTab from "../../components/bidTab/bidTab"

const Header = styled.div`
  display: flex;
  height: 56px;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0px 20px;
`

const Label = styled.span`
  font-family: montserratRegular;
  font-size: 16px;
  font-weight: 500;
  margin-left: 20px;
  flex: 3;
  text-align: left;
`

class MyPlacedBids extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mainLoader: true,
      myBids: [],
    }
  }

  componentDidMount() {
    this.loadData()
    console.log("my bids did mount!")
  }

  loadData = () => {
    const { fetchData, uniqueId, saveData } = this.props
    fetchData({
      uniqueId,

      method: "GET",
      uri: `/MyTotalBidsData`,
      onSuccess: (res) => {
        console.log({ res })
        if (res && res.myBidList) {
          this.setState({ myBids: res.myBidList, mainLoader: false })
        } else {
          this.setState({ mainLoader: false })
        }
      },
    })
  }

  myBidsHandler = (bidPath) => {
    this.props.history.push(bidPath)
  }

  render() {
    const { history } = this.props
    const { myBids } = this.state
    return (
      <div className='container'>
        <Header>
          <img
            //   onClick={() =>
            //     props.history.push(
            //       `/play/product-details/${get(props, "match.params.title")}/${get(
            //         props,
            //         "match.params.offerId"
            //       )}`
            //     )
            //   }
            // onClick={() => history.push(`/play/`)}
            onClick={() => history.goBack()}
            className='arrow'
            src={`${config.MRBIDNWIN_S3_IMAGE_URL}/arrow_back.svg`}
            alt='back-arrow'
            style={{ cursor: "pointer" }}
          />
          <Label>{i18n.t("MyBids")}</Label>
          {/* {hasData && (
        <div>
          <img
            src={`${config.MRBIDNWIN_S3_IMAGE_URL}/ic-filter.svg`}
            ref='target'
            onClick={this.handlePopoverClick}
            alt='MyBids-Filters'
          />
          <Popover
            id='simple-popper'
            open={open}
            anchorEl={anchorEl}
            onClose={this.popoverClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div style={{ padding: "10px 15px" }}>
              {filterOption.map((obj, index) => {
                return (
                  <FilterOptionContainer
                    className='checkbox_container'
                    key={index}
                  >
                    <b
                      className='montserratLight'
                      style={{ marginRight: 20 }}
                    >
                      {obj.label}
                    </b>
                    <input
                      onClick={(event) =>
                        this.handleCheckBoxClick(event, index, obj)
                      }
                      className='checkbox'
                      checked={obj.value}
                      type='checkbox'
                      disabled={obj.value}
                    />
                  </FilterOptionContainer>
                )
              })}
            </div>
          </Popover>
        </div>
      )} */}
        </Header>
        <BidTab myBids={myBids} bidClick={this.myBidsHandler} />
      </div>
    )
  }
}

MyPlacedBids = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      mapStateToProps.data = state.data[ownProps.uniqueId]
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    setHeaderTitle,
    saveData,
    showPopup,
    hidePopup,
  }
)(MyPlacedBids)

export default class MyPlacedBidsWrapper extends React.Component {
  componentDidMount() {
    this.uuid = uuid.v4()
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER ProductDetailsWrapper :: ", locale)
  }

  render() {
    return <MyPlacedBids {...this.props} uniqueId={this.uuid} />
  }
}



// WEBPACK FOOTER //
// ./src/views/MyPlacedBids/MyPlacedBids.js